<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!-- Start:: Back Button -->
      <div class="col-12 text-end mb-3">
        <v-btn @click="$router.go(-1)" style="color: #446e80">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
      <!-- End:: Back Button -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("TITLES.packageSubscribers") }} - {{ packageName }}</h5>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- End:: No Data State -->

        <!-- Start:: Serial Number -->
        <template v-slot:[`item.serialNumber`]="{ item }">
          {{
            tableRows.indexOf(item) +
            paginations.items_per_page * paginations.current_page -
            paginations.items_per_page +
            1
          }}
        </template>
        <!-- End:: Serial Number -->

        <!-- Start:: User Name -->
        <template v-slot:[`item.user_name`]="{ item }">
          {{ item.user_name }}
        </template>
        <!-- End:: User Name -->

        <!-- Start:: User Phone -->
        <template v-slot:[`item.user_phone`]="{ item }">
          {{ item.user_phone }}
        </template>
        <!-- End:: User Phone -->

        <!-- Start:: Price Without Tax -->
        <template v-slot:[`item.price_without_tax`]="{ item }">
          {{ item.price_without_tax }}
        </template>
        <!-- End:: Price Without Tax -->

        <!-- Start:: Tax -->
        <template v-slot:[`item.tax`]="{ item }">
          {{ item.tax }}
        </template>
        <!-- End:: Tax -->

        <!-- Start:: Subscription Period -->
        <template v-slot:[`item.subscription_period`]="{ item }">
          {{ item.subscription_from }} - {{ item.subscription_to }}
        </template>
        <!-- End:: Subscription Period -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template v-if="paginations.last_page > 1">
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          color="#7c0d89"
        ></v-pagination>
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
export default {
  name: "PackageSubscribers",

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      // End:: Loading Data

      // Start:: Package Data
      packageName: "",
      // End:: Package Data

      // Start:: Table Data
      tableHeaders: [
        {
          text: this.$t("TABLES.PackageSubscribers.serialNumber"),
          value: "serialNumber",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("TABLES.PackageSubscribers.user_name"),
          value: "user_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.PackageSubscribers.user_phone"),
          value: "user_phone",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.PackageSubscribers.price_without_tax"),
          value: "price_without_tax",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.PackageSubscribers.tax"),
          value: "tax",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.PackageSubscribers.subscription_period"),
          value: "subscription_period",
          align: "center",
          sortable: false,
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },
      // End:: Pagination Data
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Data
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `subscription-packages/${this.$route.params.id}/subscribers?page=${this.paginations.current_page}`,
        });
        this.loading = false;
        this.packageName = res.data.data.package_name;
        this.tableRows = res.data.data.subscribers.data;
        this.paginations.last_page = res.data.data.subscribers.meta.last_page;
        this.paginations.items_per_page =
          res.data.data.subscribers.meta.per_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows
  },

  created() {
    // Start:: Fire Methods
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.table_title_wrapper {
  margin-bottom: 20px;
}

.title_text_wrapper h5 {
  color: #7c0d89;
  font-weight: bold;
}
</style>
